import { isEmpty } from 'lodash';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import styles from './MenuCreateLabel.module.css';

/**
 * Menu.CreateLabel
 *
 * The label for a menu's create item: the action, then the search text in quotes when there is
 * one. A long search text truncates in the middle, so both quotes and its ending stay visible.
 * Pair it with an `aria-label` on the item, since the visible text can be cut short.
 */

interface MenuCreateLabelProps {
  label: string;
  query: string;
}

const MAX_TAIL_LENGTH = 8;

export function MenuCreateLabel({ label, query }: MenuCreateLabelProps) {
  // Split by code point so an emoji isn't cut in half
  const chars = Array.from(query);
  const tailLength = Math.min(Math.floor(chars.length / 2), MAX_TAIL_LENGTH);
  const head = chars.slice(0, chars.length - tailLength).join('');
  const tail = chars.slice(chars.length - tailLength).join('');

  return (
    <View className={styles.createLabel}>
      <Text size="body1" className={styles.action}>
        {label}
      </Text>
      {!isEmpty(query) && (
        <>
          <Text size="body1" weight="semibold" className={styles.fixed}>
            {' “'}
          </Text>
          <Text size="body1" weight="semibold" className={styles.head}>
            {head}
          </Text>
          <Text size="body1" weight="semibold" className={styles.fixed}>
            {`${tail}”`}
          </Text>
        </>
      )}
    </View>
  );
}
